<script setup lang="ts">
import { computed, ref } from "vue";
import { useRouter } from "vue-router";
import Avatar from "./Avatar.vue";
import Dropdown, { type MenuItem } from "./Dropdown.vue";
import AccountModal from "./AccountModal.vue";
import { session, logout } from "../composables/session";
import { t } from "../i18n";
/** Avatar button at the bottom of the rail: my account, workspace switch, platform console, extra items, logout. */
const props = defineProps<{ slug?: string; extra?: MenuItem[] }>();
const router = useRouter();
const menu = ref({ open: false, x: 0, y: 0 });
const account = ref(false);
const workspaceName = computed(
  () => session.me?.workspaces.find((w) => w.slug === props.slug)?.name ?? "",
);
const items = computed<MenuItem[]>(() => [
  ...(workspaceName.value
    ? [{ label: workspaceName.value, disabled: true }]
    : []),
  { label: session.me?.user.email ?? "", disabled: true },
  { label: "", separator: true },
  {
    label: t("account.title"),
    icon: "user",
    action: () => (account.value = true),
  },
  ...(props.extra?.length
    ? [...props.extra, { label: "", separator: true }]
    : []),
  {
    label: t("workspaces.title"),
    icon: "grid",
    action: () => void router.push("/workspaces"),
  },
  ...(session.me?.platformRole
    ? [
        {
          label: t("platform.title"),
          icon: "monitor",
          action: () => void router.push("/platform"),
        },
      ]
    : []),
  { label: "", separator: true },
  {
    label: t("auth.logout"),
    icon: "logout",
    action: () => void logout().then(() => router.replace("/login")),
  },
]);
function open(e: MouseEvent) {
  const r = (e.currentTarget as HTMLElement).getBoundingClientRect();
  menu.value = { open: true, x: r.left, y: r.top - 8 };
}
</script>
<template>
  <button class="profile-nav" :aria-label="t('auth.account')" @click="open">
    <Avatar :name="session.me?.user.name ?? ''" :size="28" tone="green" />
  </button>
  <Dropdown
    :open="menu.open"
    :x="menu.x"
    :y="menu.y"
    :items="items"
    @close="menu.open = false"
    @select="menu.open = false"
  />
  <AccountModal :open="account" @close="account = false" />
</template>
